import React, { useState, useEffect } from "react";
import UpArrow from "../images/svg/chevron-up.svg";
 
const ScrollToTop = () => {
    const [showTopBtn, setShowTopBtn] = useState(false);

    useEffect(() => {
        window.addEventListener('scroll', () => {
            if (window.scrollY > 400) {
                setShowTopBtn(true);
            } else {
                setShowTopBtn(false);
            }
        });
    }, []);

    const goToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth',
        });
    };

    // Keypress added for accessibility
    const keyboardScrollToTop = (e) => {
        
        if (e.keyCode === 13) {
            goToTop();
        }
    }

    return (
        <>
            {showTopBtn && (
                <div className="scroll-to-top">
                    <div className="scroll-to-top__icon" onClick={goToTop} onKeyUp={keyboardScrollToTop} role="button" tabIndex={0}>
                        <UpArrow height="20px"/> 
                    </div>
                </div>
            )}
        </>
    );
}

export default ScrollToTop;